import ticket from "./getTicket.json"

export const fetchGetTicket = async (orderId: string) => new Promise((res) => setTimeout(() => res(ticket), 2000))
